export const removeAreaCodeFromPhoneNumber = (phoneNumber?: string): string => {
    if (!phoneNumber) return '';
    return phoneNumber.split(' ')[1];
};

export const getAreaCode = (phoneNumber?: string): string => {
    if (!phoneNumber) return '';
    return phoneNumber.split(' ')[0].slice(1);
};
